export default __webpack_public_path__ + "static/media/profile_setting.00a9cf11.png";